import { render, staticRenderFns } from "./AssessmentList.vue?vue&type=template&id=25991a2b"
import script from "./AssessmentList.vue?vue&type=script&lang=ts"
export * from "./AssessmentList.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AssessmentList.vue?vue&type=style&index=1&id=25991a2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports